export class MinimalEntity {
	readonly id: string
	readonly name: string
	readonly tcn: int
}

export class BaseEntity extends MinimalEntity {
	readonly description: string
	readonly createDate: string
	readonly updateDate: string
}
